awardCalculation.classy.controller({
    name: 'TaxesControllerRight',
    inject: ['$scope', '$http', 'RestService', 'BinFactory', 'ApplicationService', 'SchoolModelService', 'DateService', 
        'CalculationService', 'ModelService', 'ResetService'],
    init: function() 
    {
        this.$.School_Country = this.SchoolModelService.get()[0].School_Country;
        this.$.isArchive = this.BinFactory.isArchive();
        this.$.DateService = this.DateService;
        this.$.ResetService = this.ResetService;
    },
    taxesPut: function(scope, instance, form)
    {
        instance.options.factor = .3;
        var parent = this;
        var data = this.ApplicationService.getFamilyData().edit_sums;
        var putData = {};
        putData.Tax_Fed = data.Tax_Fed;
        putData.Tax_State = data.Tax_State;
        //this.ModelService.EditSumsService.putHelper(data, putData, this.CalculationService.reCalc);
        putData.applicationID = data.applicationID;
        putData.familyID = data.familyID;
        return this.$http.put("/api/family/" + putData.familyID + '/editsums/' + data.applicationID, data).success(function(data, status, headers, config) {
            parent.CalculationService.reCalc();
            instance.options.callMe(data, status, headers, config, instance);
        });
    }

});
